/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const Grid2SolidV6 = (props) => (
  <Icon {...props} name="Grid 2 Solid V6">
    <path d="M7 5.5A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3zm0 8A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3zm2-11A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm6 11a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3z" />
  </Icon>
);

export default Grid2SolidV6;
